import React from 'react'

type FrameContextValue = {
    headerHeight: number
}

export const FrameContext = React.createContext<FrameContextValue>({
    headerHeight: 0,
})
